import { render, staticRenderFns } from "./ProcessParents.vue?vue&type=template&id=1ae211e8&scoped=true&"
import script from "./ProcessParents.vue?vue&type=script&lang=ts&"
export * from "./ProcessParents.vue?vue&type=script&lang=ts&"
import style0 from "./ProcessParents.vue?vue&type=style&index=0&id=1ae211e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae211e8",
  null
  
)

export default component.exports